import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import Vue from 'vue';

Bugsnag.start({
    apiKey: window.App.bugsnagKey,
    releaseStage: window.App.env,
    metaData: {
        user: window.shared.auth && window.shared.auth.user ? window.shared.auth.user : undefined,
    },
    plugins: [new BugsnagPluginVue(Vue)],
});
